import { LocationConditionEnum, PrefixIcon, PrefixIconColorKeys, TextAppearanceKeys, TextEmphasisKeys } from '@/constants/enum';
import { IStateCheckoutRule } from '@/pages/Checkout/components/CreateUpdate';
import { IError } from '@/types/components/settings';
import { IRule } from '@/types/newSetup.type';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { initialRuleState } from './rule.slice';
import { initCheckoutRuleState } from '@/redux/slice/checkoutRule.slice';

interface IState {
  step_active: number;
  error: IError;
  rule: IRule;
  isAllowedSaveRule: boolean;
  isAllowedSaveCheckoutRule: boolean;
  locationConditionSelected?: LocationConditionEnum;
  checkoutRule: IStateCheckoutRule;
}

// Define the initial state using that type
export const initialState: IState = {
  step_active: 1,
  error: { status: false, msg: '' },
  rule: initialRuleState,
  isAllowedSaveRule: true,
  isAllowedSaveCheckoutRule: true,
  locationConditionSelected: undefined,
  checkoutRule: {
    ...initCheckoutRuleState,
    iconId: PrefixIcon.truck,
    textAppearance: TextAppearanceKeys.accent,
    iconColor: PrefixIconColorKeys.accent,
    textEmphasis: TextEmphasisKeys.bold,
  },
};

export const onboardingSlice = createSlice({
  name: 'onboarding',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    handleUpdateOnboarding: (state, action: PayloadAction<IState>) => {
      return action.payload;
    },
    handleSetError: (state, action: PayloadAction<IError>) => {
      state.error = action.payload;
    },
    handleChangeRule: (state, action: PayloadAction<{ key: keyof IRule; value: IRule[keyof IRule] }>) => {
      const { key, value } = action.payload;
      state.rule = { ...state.rule, [key]: value };
    },
    handleChangeCheckoutRule: (state, action: PayloadAction<Partial<IStateCheckoutRule>>) => {
      state.checkoutRule = { ...state.checkoutRule, ...action.payload };
    },
  },
});

// Other code such as selectors can use the imported `RootState` type
export const onboardingSelector = createSelector(
  (state: RootState) => state.onboarding,
  (state) => state,
);

export default onboardingSlice;
